import { useEffect } from 'react';
import { clearWorkspacePermissions, resolveWorkspacePermissions } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';

/**
 * Seeds and refreshes the workspace-scoped permission list whenever the active
 * workspace changes. Lives in the always-mounted app shell so workspace-level
 * gates (e.g. creating a project) resolve once per workspace and re-resolve on
 * an in-session workspace switch.
 */
export function useResolveWorkspacePermissions(): void {
  const workspaceId = useCurrentWorkspaceId();

  useEffect(() => {
    if (workspaceId) {
      resolveWorkspacePermissions(workspaceId);
    } else {
      clearWorkspacePermissions();
    }
  }, [workspaceId]);
}
